import { useEffect } from "react";
import Navbar from "@/components/Navbar";

export default function Blog() {
  useEffect(() => {
    if (document.getElementById("soro-blog-script")) return;
    const s = document.createElement("script");
    s.id = "soro-blog-script";
    s.src = "https://app.trysoro.com/api/embed/3631f940-a03b-4766-9d3f-8f3bf40ec8af";
    s.defer = true;
    document.body.appendChild(s);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-32 pb-20 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-xs tracking-[0.35em] uppercase text-primary mb-3">Journal</p>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-foreground">
              The 7 Star Blog
            </h1>
            <p className="text-muted-foreground mt-4 max-w-2xl mx-auto">
              Travel tips, chauffeur stories, and the finer points of luxury ground transportation in Houston and beyond.
            </p>
          </div>
          <div
            id="soro-blog"
            data-testid="soro-blog-container"
            className="border border-white/10 bg-[#121212] p-6 sm:p-10 min-h-[400px]"
          />
        </div>
      </main>
    </div>
  );
}
